import { ArrowLeft } from 'lucide-react'

function BackButton({ onClick }) {
  return (
    <button type="button" className="back-button" onClick={onClick} aria-label="Volver">
      <ArrowLeft size={20} />
    </button>
  )
}

export default BackButton
